import {getFormatedDate} from 'react-native-modern-datepicker';

const dateToString = (date = new Date()) =>
  getFormatedDate(date, 'jYYYY/jM/jDD');

export default dateToString;
